<script setup lang="ts">
import { useVModel } from '@vueuse/core';
import { connectSortBy } from 'instantsearch.js/es/connectors';
import {
  SortByConnectorParams,
  SortByItem,
  SortByWidgetDescription,
} from 'instantsearch.js/es/connectors/sort-by/connectSortBy';
import { computed, PropType } from 'vue';
// @ts-expect-error (function lacks types; this should be converted in the near future)
import { createSuitMixin } from 'vue-instantsearch/vue3/es';

import CollapsibleWidget from '@/components/search/widgets/CollapsibleWidget.vue';
import { useWidget } from '@/composables/instant-search/useWidget';

defineOptions({
  mixins: [createSuitMixin({ name: 'Menu' })],
});

const props = defineProps({
  items: { required: true, type: Array as PropType<SortByItem[]> },
  header: { required: true, type: String },
  modelValue: { required: false, type: Boolean, default: true },
});

const emit = defineEmits(['update:modelValue', 'click']);

const open = useVModel(props, 'modelValue', emit);

const widgetParams = computed<SortByConnectorParams>(() => ({ items: props.items }));
const { state } = useWidget<SortByWidgetDescription, SortByConnectorParams>(
  { connector: connectSortBy },
  widgetParams,
);
const refine = (value: string) => {
  state.value?.refine(value);
  emit('click');
};
</script>

<template>
  <div v-if="state">
    <CollapsibleWidget
      v-model="open"
      attribute="sortBy"
      :header="header"
      panelLocator="sort-by-menu-list"
      showPanel
    >
      <div :class="suit()">
        <ul :class="suit('list')">
          <li
            v-for="item in state.options"
            :key="item.value"
            :class="[
              suit('item'),
              { [suit('item', 'selected')]: item.value === state.currentRefinement },
            ]"
          >
            <a :class="suit('link')" href="#" @click.prevent="refine(item.value)">
              <span :class="suit('label')">{{ item.label }}</span>
            </a>
          </li>
        </ul>
      </div>
    </CollapsibleWidget>
  </div>
</template>
